import * as React from "react"

const HorizontalLinePinBlue = props => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 585.03 51.42"
    {...props}
  >
    <defs>
      <radialGradient
        id="a"
        cx={1429.09}
        cy={2048.46}
        r={81.79}
        gradientTransform="matrix(0 -1 -1 0 2049.14 1457.74)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0} stopColor="#4ead90" />
        <stop offset={0.07} stopColor="#4b9d88" />
        <stop offset={0.25} stopColor="#467a76" />
        <stop offset={0.42} stopColor="#416169" />
        <stop offset={0.58} stopColor="#3f5161" />
        <stop offset={0.7} stopColor="#3e4c5e" />
        <stop offset={0.74} stopColor="#364253" />
        <stop offset={0.84} stopColor="#262d3a" />
        <stop offset={0.93} stopColor="#1c202a" />
        <stop offset={1} stopColor="#181c25" />
      </radialGradient>
      <radialGradient
        id="c"
        cx={1441.05}
        cy={2003.35}
        r={36.48}
        xlinkHref="#a"
      />
      <linearGradient
        id="b"
        x1={1444.89}
        y1={1991.67}
        x2={1444.89}
        y2={2055.17}
        gradientTransform="matrix(0 -1 -1 0 2049.14 1457.74)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0} stopColor="#181c25" />
        <stop offset={0.17} stopColor="#1c202a" />
        <stop offset={0.37} stopColor="#262d3a" />
        <stop offset={0.59} stopColor="#364253" />
        <stop offset={0.68} stopColor="#3e4c5e" />
        <stop offset={0.72} stopColor="#42636a" />
        <stop offset={0.8} stopColor="#47837a" />
        <stop offset={0.87} stopColor="#4b9a86" />
        <stop offset={0.94} stopColor="#4da88e" />
        <stop offset={1} stopColor="#4ead90" />
      </linearGradient>
    </defs>
    <title>{"Horizontal-Blue-Map-Pin-White-Line-2"}</title>
    <path
      d="M84.58 31.89h150.5a7.7 7.7 0 0 0 9.82 0h153.05a7.71 7.71 0 0 0 9.83 0h151.3a13.65 13.65 0 1 0 0-11.84h-151.3a7.68 7.68 0 0 0-9.83 0H244.87a7.67 7.67 0 0 0-9.82 0H84.58a13.65 13.65 0 1 0 0 11.84ZM408.41 26a5.55 5.55 0 1 1-5.55-5.55 5.54 5.54 0 0 1 5.55 5.55Zm-162.9 0a5.55 5.55 0 1 1-5.55-5.55 5.54 5.54 0 0 1 5.55 5.55Zm325.87-10.45A10.42 10.42 0 1 1 560.96 26a10.43 10.43 0 0 1 10.42-10.45ZM61.88 26a10.42 10.42 0 1 1 10.45 10.39A10.43 10.43 0 0 1 61.88 26Zm17.93 0a7.51 7.51 0 1 0-7.51 7.51A7.51 7.51 0 0 0 79.81 26Zm-13.24 0a5.74 5.74 0 1 1 5.75 5.73A5.75 5.75 0 0 1 66.57 26Zm504.81 7.48a7.51 7.51 0 1 0-7.5-7.48 7.52 7.52 0 0 0 7.5 7.48Zm0-13.24a5.73 5.73 0 1 1-5.73 5.76 5.74 5.74 0 0 1 5.73-5.76Z"
      fill="#fff"
    />
    <path
      d="M25.71 38.25c-6.5 0-12.27-6-12.27-12.54H0a25.66 25.66 0 0 0 36.73 23.2c18.68-8.09 36.73-23.24 36.73-23.24H38c0 6.54-5.79 12.58-12.29 12.58Z"
      transform="translate(.08)"
      fill="url(#a)"
    />
    <path
      d="M25.71 0A25.71 25.71 0 0 0 0 25.71h13.14c0-6.5 6.07-12.54 12.57-12.54s12.76 6 12.76 12.54h35s-18-15.14-36.73-23.24A25.68 25.68 0 0 0 25.71 0Z"
      transform="translate(.08)"
      fill="url(#b)"
    />
    <path
      d="M12 12a19.33 19.33 0 1 0 27.34 0A19.33 19.33 0 0 0 12 12Zm25.48 13.71a11.78 11.78 0 1 1-11.79-11.77 11.77 11.77 0 0 1 11.79 11.77Z"
      transform="translate(.08)"
      fill="url(#c)"
    />
    <path
      d="M25.79 0a25.71 25.71 0 1 0 11 48.91c18.68-8.09 36.73-23.24 36.73-23.24s-18-15.14-36.73-23.24a25.51 25.51 0 0 0-11-2.43Zm11.77 25.71a11.78 11.78 0 1 1-11.79-11.77 11.77 11.77 0 0 1 11.79 11.77Z"
      fill="#3e4c5e"
    />
  </svg>
)

export default HorizontalLinePinBlue
